import getAmountPaid from 'components/orders/helpers/getAmountPaid'

export default function hasIncompletePayment(order) {
  const paid = getAmountPaid(order)

  return paid > 0 && paid < order.total
}